import { render, staticRenderFns } from "./CreatorPage.vue?vue&type=template&id=70bd4f6c&"
import script from "./CreatorPage.vue?vue&type=script&lang=js&"
export * from "./CreatorPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports